/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetConsentDecisionByTokenRequest} from '@cash-web/protos/squareup/consentsys/service.pb'
import {GetConsentDecisionResponse} from '@cash-web/protos/squareup/consentsys/service.pb'


export const getConsentDecisionByToken = (request:GetConsentDecisionByTokenRequest, options?: CashRequestOptions) => post<GetConsentDecisionByTokenRequest, GetConsentDecisionResponse>("/2.0/cash/get-consent-decision-by-token", request, {...options, rejectOnError: true })